import { httpClient } from '@api';

export default {
  list: async (payload) => httpClient.post('filter/list', payload),
  create: async (payload) => httpClient.post('filter/new', payload),
  update: async (payload) => httpClient.post('filter/update', payload),
  delete: async (payload) => httpClient.post('filter/delete', payload),
};
